<div class="modal-body">
  <div class="row">
    <div class="col">
      <h2>{{ 'brapi-sync.connections.source' | translate }}</h2>
      <div class="card">
        <div class="card-body">
          <form>
            <div class="form-group row">
              <label for="source" class="col-auto col-form-label">{{ 'brapi-sync.connections.brapi-base-url' | translate }}</label>
              <div class="col-5">
                <input type="text" class="form-control" id="source" name="source" placeholder="{{BRAPI_SYNC_BASE_URL_PLACEHOLDER}}" [(ngModel)]="context.source">
              </div>
            </div>
            @if (!context.isEmbedded) {
              <h4 class="pt-2">{{ 'brapi-sync.connections.authentication' | translate }}</h4>
            }
            @if (!context.isEmbedded) {
              <div class="form-group row pt-2">
                <div class="col">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="sourceAuthDelegated" id="delegatedSourceAuth" [value]="authenticationType.DELEGATED" [(ngModel)]="sourceAuth">
                    <label class="form-check-label" for="delegatedSourceAuth">{{ 'brapi-sync.connections.delegated' | translate }}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="sourceAuthToken" id="tokenSourceAuth" [value]="authenticationType.TOKEN" [(ngModel)]="sourceAuth">
                    <label class="form-check-label" for="tokenSourceAuth">{{ 'brapi-sync.connections.token' | translate }}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="sourceAuthCredentials" id="credentialsSourceAuth" [value]="authenticationType.CREDENTIALS" disabled [(ngModel)]="sourceAuth">
                    <label class="form-check-label" for="credentialsSourceAuth">{{ 'brapi-sync.connections.credentials' | translate }}</label>
                  </div>
                </div>
              </div>
            }
            @if (sourceAuth == authenticationType.TOKEN) {
              <div class="form-group row pt-2">
                <label for="sourceToken" class="col-auto col-form-label">{{ 'brapi-sync.connections.token' | translate }}</label>
                <div class="col-5">
                  <input type="text" class="form-control" id="sourceToken" name="sourceToken" [(ngModel)]="context.sourceToken">
                </div>
              </div>
            }
            @if (sourceAuth == authenticationType.DELEGATED) {
              <div class="form-group row pt-2">
                <div class="col">
                  <button type="button" class="btn btn-info" (click)="loginSource()">{{ 'brapi-sync.buttons.login' | translate }}</button>
                </div>
              </div>
            }
            @if (sourceSuccess) {
              <div class="row pt-2">
                <span>&nbsp;<i class="fa fa-check text-success"></i> {{ 'brapi-sync.connections.connected' | translate }}</span>
              </div>
            }
          </form>
        </div>
      </div>

    </div>
  </div>
  @if (!context.isEmbedded) {
    <div class="row pt-3">
      <div class="col">
        <h2>{{ 'brapi-sync.connections.destination' | translate }}</h2>
        <div class="card">
          <div class="card-body">
            <form>
              <div class="form-group row">
                <label for="destination" class="col-auto col-form-label">{{ 'brapi-sync.connections.brapi-base-url' | translate }}</label>
                <div class="col-5">
                  <input type="text" class="form-control" id="destination" name="destination" placeholder="{{BRAPI_SYNC_BASE_URL_PLACEHOLDER}}" [(ngModel)]="context.destination">
                </div>
              </div>
              <h4 class="pt-2">{{ 'brapi-sync.connections.authentication' | translate }}</h4>
              <div class="form-group row pt-2">
                <div class="col">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="destinationAuthDelegated" id="delegatedDestinationAuth" [value]="authenticationType.DELEGATED" [(ngModel)]="destinationAuth">
                    <label class="form-check-label" for="delegatedDestinationAuth">{{ 'brapi-sync.connections.delegated' | translate }}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="destinationAuthToken" id="tokenDestinationAuth" [value]="authenticationType.TOKEN" [(ngModel)]="destinationAuth">
                    <label class="form-check-label" for="tokenDestinationAuth">{{ 'brapi-sync.connections.token' | translate }}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="destinationAuthCredentials" id="credentialsSourceAuth" [value]="authenticationType.CREDENTIALS" disabled [(ngModel)]="destinationAuth">
                    <label class="form-check-label" for="credentialsSourceAuth">{{ 'brapi-sync.connections.credentials' | translate }}</label>
                  </div>
                </div>
              </div>
              @if (destinationAuth == authenticationType.TOKEN) {
                <div class="form-group row pt-2">
                  <label for="sourceToken" class="col-auto col-form-label">{{ 'brapi-sync.connections.token' | translate }}</label>
                  <div class="col-5">
                    <input type="text" class="form-control" id="destinationToken" name="destinationToken" [(ngModel)]="context.destinationToken">
                  </div>
                </div>
              }
              @if (destinationAuth == authenticationType.DELEGATED) {
                <div class="form-group row pt-2">
                  <div class="col">
                    <button type="button" class="btn btn-info" (click)="loginDestination()">{{ 'brapi-sync.buttons.login' | translate }}</button>
                  </div>
                </div>
              }
              @if (destSuccess) {
                <div  class="row pt-2">
                  <span>&nbsp;<i class="fa fa-check text-success"></i> {{ 'brapi-sync.connections.connected' | translate }}</span>
                </div>
              }
            </form>
          </div>
        </div>
      </div>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-info" (click)="next()" [disabled]="loading">
    @if (loading) {
      <span class="throbber throbber-btn throbber-btn-dark"></span>
    }
    {{ 'next' | translate }}
  </button>
</div>
